import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { fetchArticlesByPromotion } from "../../../api/articles";
import ArticlesTable from "../../../components/articles-table/ArticlesTable";
import { toast } from "../../../helpers/smu-alerts/smu-lerts";

const brand = process.env.REACT_APP_BRAND || "S10";

const Articles = () => {
  const { promotionId } = useParams();

  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!promotionId) {
      setArticles([]);
      return toast({ icon: "error", title: "Error en Id de Promoción." });
    }

    const _code = Number(promotionId);
    setLoading(true);
    fetchArticlesByPromotion(brand, _code)
      .then(({ data, error }) => {
        if (!!error) throw new Error(error?.message);
        setArticles(data.O_ARTICULOS);
      })
      .catch((err) => {
        console.error(err);//toast({ icon: "error", title: err });
      })
      .finally(() => setLoading(false));
  }, [promotionId]);

  return (
    <Row>
      <Col col={12} className="mb-4">
        <ArticlesTable
          articles={articles}
          promotionId={promotionId}
          loading={loading}
        />
      </Col>
    </Row>
  );
};

export default Articles;
